export const NAME = 'certMailElements';
